import React from "react";
import { Modal } from "../..";
import "./style.scss";
import { helpers } from "../../../services";

const DetailModal = ({ selected, detailModal, setDetailModal }) => {
  const goods = (selected && selected.goods) || [];
  const transactions = (selected && selected.transactions) || [];

  return (
    <Modal size={600} isOpen={detailModal} toggle={() => setDetailModal(false)}>
      <div className="detail-modal">
        <div className="detail-header">
          <h3>Детали заказа</h3>
        </div>

        <div className="info-block">
          <div>
            <strong>Организация:</strong>{" "}
            {selected &&
              selected.client_organization &&
              selected.client_organization.name}
          </div>
          <div>
            <strong>Дата:</strong>{" "}
            {helpers.formatDate(selected && selected.created_at)}
          </div>
          <div>
            <strong>Общая цена:</strong>{" "}
            {(selected &&
              selected.price &&
              helpers.convertToReadable(selected.price)) ||
              "—"}{" "}
            сум
          </div>
        </div>

        <div className="goods-list">
          <h4>Транзакции </h4>
          {transactions.length === 0 ? (
            <div className="empty">Нет данных</div>
          ) : (
            <table className="goods-table">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Создано</th>
                  <th>Цена</th>
                  <th>Комментария</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((item, idx) => (
                  <tr key={idx}>
                    <td>{(item && item.user.name) || "—"}</td>
                    <td>{item && helpers.formatDate(item.created_at)}</td>
                    <td>{(item && item.value) || selected.price || "0"}</td>
                    <td>{item && item.comment}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="goods-list">
          <h4>Продукты</h4>
          {goods.length === 0 ? (
            <div className="empty">Нет данных</div>
          ) : (
            <table className="goods-table">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Кол-во</th>
                  <th>Цена</th>
                  <th>Комментария</th>
                </tr>
              </thead>
              <tbody>
                {goods.map((item, idx) => (
                  <tr key={idx}>
                    <td>{(item && item.product.name) || "—"}</td>
                    <td>{item && item.quantity}</td>
                    <td>{(item && item.price) || selected.price || "0"}</td>
                    <td>{item && item.comment}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DetailModal;
